import { Injectable } from '@angular/core';
import { IUserDetails } from '../../app.model';
import { AppService } from '@irb/app.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PageService {
  _isReady: boolean = false;
  _userDetails: IUserDetails;
  pageState: any = {};

  constructor(private as: AppService) {}

  getUserDetails(): Observable<Object> {
    return new Observable(obs => {
        this.as.getUserDetails().subscribe((data) => {
            this.userDetails = data as IUserDetails;
            this.isReady = true;
            obs.next(this.userDetails);
        });
    });
  }

  hasAnyRole(roles: Array<string>): boolean {
      let hasAnyRole = false;

      roles.forEach(role => {
          switch(role) {
            case "ROLE_TRADER":
                if(!hasAnyRole && this.userDetails.isTrader) {
                    hasAnyRole = true;
                }
                break;
            case "ROLE_MODEL_SEC_MANAGER":
                if(!hasAnyRole && this.userDetails.isModelSecManager) {
                    hasAnyRole = true;
                }
                break;
            case "ROLE_IREBAL_ACCESS":
                if(!hasAnyRole && this.userDetails.isIrebalAccess) {
                    hasAnyRole = true;
                }
                break;
            case "MMC_ADMIN":
                if(!hasAnyRole && this.userDetails.isMMCAdmin) {
                    hasAnyRole = true;
                }
                break;
            case "ROLE_ADMIN":
                if(!hasAnyRole && this.userDetails.isAdmin) {
                    hasAnyRole = true;
                }
                break;
            case "ROLE_HIDE_MODEL_MARKET_CENTER":
                  if (!hasAnyRole && this.userDetails.isHideModelMarketCenter) {
                      hasAnyRole = true;
                  }
                  break;

          }
      });

      return hasAnyRole;
  }

  serializePageState(): void {
      this.as.setToSession("pageState",JSON.stringify(this.pageState));
  }

  deserializePageState(pageStateParameter: string, defaultIdList: Array<string>): void {
      //let d:any = {};
      
      if (pageStateParameter != 'null' && typeof pageStateParameter != 'undefined' && pageStateParameter.length > 0) {
          //d = JSON.parse(unescape(pageStateParameter));
          
          //ensure that default ids are available
          for(let i = 0; i < defaultIdList.length; i++) {
              if(!this.pageState[defaultIdList[i]]) {
                this.pageState[defaultIdList[i]] = {filterData:{},filterString:""};
              }
          }
          
          //only allow default ids to be available
          /*for(let id in d) {
              let isDefault = false;
              
              for(let i = 0; i < defaultIdList.length; i++) {
                  if(id == defaultIdList[i]) {
                      isDefault = true;
                      break;
                  }
              }
              
              if(!isDefault) {
                  delete d[id];
              }
          }*/
      } else {            
          for(let i = 0; i < defaultIdList.length; i++) {
            this.pageState[defaultIdList[i]] = {filterData:{},filterString:""};
          }
      }
      
      //this.pageState = d;
  }

  get isReady() {
    return this._isReady;
  }

  set isReady(b: boolean) {
    this._isReady = b;
  }

  get userDetails() {
      return this._userDetails;
  }

  set userDetails(ud: IUserDetails) {
      this._userDetails = ud;
  }
}
